<div>
  {{registro.objeto.cultivar}}
  <br/>
  Densidade: {{registro.objeto.density | number}} pl/ha
  {{registro.objeto.observacoes ? '<br/>' + registro.objeto.observacoes : ''}}
</div>